import { useEffect, useRef } from 'react';

export const usePasteImage = (onImage: (file: File) => void, enabled: boolean = true) => {
  const onImageRef = useRef(onImage);
  onImageRef.current = onImage;

  useEffect(() => {
    if (!enabled) return;
    const handlePaste = (e: Event) => {
      const items = (e as ClipboardEvent).clipboardData?.items;
      if (!items) return;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.startsWith('image/')) {
          const file = item.getAsFile();
          if (file) {
            e.preventDefault();
            onImageRef.current(file);
          }
          break;
        }
      }
    };
    window.addEventListener('paste', handlePaste);
    return () => window.removeEventListener('paste', handlePaste);
  }, [enabled]);
};
